import { apiGet, apiPut } from '../client';
import type { GetAllUsersResponseApi, UpdateUserRoleRequestApi, UserResponseApi } from '../models/user';

export async function getCurrentUser(): Promise<UserResponseApi> {
  return apiGet<UserResponseApi>('users/self');
}

export async function getAllUsers(): Promise<GetAllUsersResponseApi> {
  return apiGet<GetAllUsersResponseApi>('users');
}

export async function updateSelf(preferences: Record<string, string>): Promise<UserResponseApi> {
  return apiPut<UserResponseApi>('users/self', { preferences });
}

export async function updateUserRole(userId: string, request: UpdateUserRoleRequestApi): Promise<UserResponseApi> {
  return apiPut<UserResponseApi>(`users/${userId}/role`, request);
}

export async function getUsersByPermission(permissionKey: string): Promise<GetAllUsersResponseApi> {
  return apiGet<GetAllUsersResponseApi>(`users/by-permission/${permissionKey}`);
}
